import * as React from 'react';
const SvgCurrencyYen = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M9.458 16.04v-2.334H6.25a.52.52 0 0 1-.386-.156.52.52 0 0 1-.156-.385q0-.228.156-.382a.53.53 0 0 1 .386-.154h3.208v-1.837H6.25a.52.52 0 0 1-.386-.156.52.52 0 0 1-.156-.386q0-.23.156-.386a.52.52 0 0 1 .386-.155h2.835L5.555 4.27a.51.51 0 0 1-.034-.562.51.51 0 0 1 .485-.292.57.57 0 0 1 .467.258L10 9.143l3.527-5.489a.5.5 0 0 1 .206-.175.6.6 0 0 1 .262-.062q.332 0 .484.284a.51.51 0 0 1-.034.562l-3.53 5.446h2.835q.23 0 .386.154t.156.383-.156.385a.52.52 0 0 1-.386.156h-3.208v1.842h3.208q.23 0 .386.154t.156.383-.156.384a.52.52 0 0 1-.386.156h-3.208v2.335a.53.53 0 0 1-.156.386.52.52 0 0 1-.386.157.52.52 0 0 1-.386-.157.53.53 0 0 1-.156-.386'
            />
        </g>
    </svg>
);
export default SvgCurrencyYen;
